import gql from "graphql-tag";

export const GET_LSS_IMPAIRMENT_PERMITS = gql`
  query ($site: String!, $searchText: String, $startDate: String, $endDate: String) {
    GetLssImpairmentPermits(site: $site, searchText: $searchText, startDate: $startDate, endDate: $endDate) {
      code
      success
      message
      results {
        _id
        parentPermit
        parentPermitId
        parentPermitNumber
        lssChildPermit
        childPermitId
        lssChildPermitNumber
        requesterName
        hostName
        workDescription
        typeOfLssNeedToImpair
        startDateAndTime
        endDateAndTime
        site
        affectedArea
        status
        startDate
      }
    }
  }
`;